import React, {Fragment, useEffect} from 'react';
import M from 'materialize-css';
import { useAuth } from '../Context/Context';
import { WavyLink } from "react-wavy-transitions";

import Portafolio from '../Components/Portafolio';
import Contacto from '../Components/Contacto'


const Nosotros = () => {
  const { direction, cambio } = useAuth();
  
  useEffect(() => {
    var elems = document.querySelectorAll('.sidenav');
    M.Sidenav.init(elems);
  });


    return (
      <Fragment>

        <div class="text_efefect">
          <p className='titulo_nv_2 espacio_bajo_1' style={{textAlign:"center"}}>Somos</p>
          <p className='text_move titulo_nv_2' style={{color:"#A741AF", textAlign:"center", margin:"0"}}>
            <div class="text_inner">
              <p className='texto_animado'>Profesionales</p>
              <p className='texto_animado'>Apasionados</p>
              <p className='texto_animado'>Creativos</p>
              <p className='texto_animado'>Curiosos</p>
              <p className='texto_animado'>Innovadores</p>
            </div>
          </p>
        </div>

        <div className='cont_11'>
          <p style={{textAlign:"center"}}>
            Somos apasionados en el tema de la <span style={{color:"#BF1F60", fontWeight:"bold"}}>tecnología</span><br />
            y de cómo ésta puede mejorar por completo a una empresa.
          </p>
          <p style={{textAlign:"center"}}>
            Hemos colaborado con increíbles empresas de México y USA.<br />
            Definitivamente queremos ser parte del éxito de tu proyecto.
          </p>
        </div>

        <p className='sub_titulo_nv_5' style={{color:"#2A79B0", textAlign:"center"}}>¡Hagamos equipo!</p>

        <div className='centrar-boton'>
          <WavyLink direction={direction ? "up" : "down"} to="/servicios" color={direction ? "#BF1F60" : "#2A79B0"}>
            <p class="boton btn-servicios z-depth-4" onClick={cambio} style={{height:"auto", padding:"10px 20px", lineHeight:"25px", margin:"0px"}}>
              Conoce todos <br />
              nuestros servicios 
            </p>
          </WavyLink>
          {/* <a class="boton btn-servicios z-depth-4" style={{height:"auto", padding:"10px 20px", lineHeight:"25px"}} href='/servicios'>
            Conoce todos <br />
            nuestros servicios 
          </a>     */}
        </div>

        <div style={{background:"#101014", padding:"50px 0", marginTop:"50px"}}>
          <div className='container' style={{marginTop:"30px"}}>
            <div class="contenedor_video">
              <iframe
                title="¡Hagamos equipo!"
                className='video'
                src="https://www.youtube.com/embed/M74WlRxj1nQ?modestbranding=1&rel=0&fs=0"
              ></iframe>
            </div>
          </div>
        </div>

        <Portafolio />

        <Contacto/>
        
      </Fragment>
    );
}

export default Nosotros;
